module.exports = __webpack_public_path__ + "img/Vector (1).0e70a32d.svg";